import { create } from "zustand";
import { devtools } from "zustand/middleware";
import config from "../../config";

const initialState = {
  user: null,
  userLoading: true,
  isPCAdmin: false,
  isAdmin: false,
  isAgent: false,
  isViewResiduals: false,
  userOrgIsPaychex: false,
  userOrgIsEMS: false,
  organizationId: null,
};

const useUserStore = create(
  devtools((set, get) => ({
    ...initialState,
    setUserLoading: (loading) => set({ userLoading: loading }),
    setUser: (user) =>
      set({
        user,
        organizationId: user?.organization_id,
        agentUrl: user?.agent_url,
        isAgent: user?.organization_id > 1 && user?.role === "agent",
        isEMSUser: user?.is_ems_user,
        isAdmin: user?.role === "admin",
        isPCAdmin: user?.is_pc_admin,
        isEMSPCAdmin: user?.is_ems_pc_admin,
        isViewResiduals: user?.is_view_residuals,
        userOrgIsPaychex:
          user?.organization_id == config.paymentcloud.PAYCHEX_ORG_ID,
        userOrgIsEMS: user?.organization_id == config.paymentcloud.EMS_ORG_ID,
        userLoading: false,
      }),
    logout: () => set({ ...initialState }),
  })),
);

export default useUserStore;
